// src/stores/flightTrackPreviewStore.ts
//
// Cross-route handoff for AeroAPI flight tracks.
//
// When the user taps a flight row in AircraftPage's Recent Flights section,
// the track is stored here and the user is navigated to /map. MapPage reads
// this on mount and clears it, rendering the track exactly like TailLookupSheet.
//
// Intentionally tiny — just one field and two actions.

import { create } from 'zustand';
import type { FlightTrackResponse } from '../../api/flightaware/flight-track';

interface FlightTrackPreviewState {
  pending: FlightTrackResponse | null;
  set: (track: FlightTrackResponse) => void;
  consume: () => FlightTrackResponse | null;
}

export const useFlightTrackPreviewStore = create<FlightTrackPreviewState>((set, get) => ({
  pending: null,
  set: (track) => set({ pending: track }),
  consume: () => {
    const { pending } = get();
    if (pending) set({ pending: null });
    return pending;
  },
}));
